import React from 'react';
import {
  INITIAL_PLAN_DOWNLOAD_FILE_MONTHLY,
  INITIAL_PLAN_DOWNLOAD_FILE_WEEKLY,
  INITIAL_PLAN_MONTHLY_SPEND,
  INITIAL_PLAN_WEEKLY_HEADERS,
  INITIAL_PLAN_WEEKLY_SPEND,
} from '../constants';
import CurrentPlanSpend from '../../currentPlanSpend';

export const InitialPlanSpend = () => {
  return (
    <CurrentPlanSpend
      WEEKLY_SPEND_COMPONENT={INITIAL_PLAN_WEEKLY_SPEND}
      MONTHLY_SPEND_COMPONENT={INITIAL_PLAN_MONTHLY_SPEND}
      WEEKLY_HEADERS_COMPONENT={INITIAL_PLAN_WEEKLY_HEADERS}
      title="Initial Plan Spend"
      DOWNLOAD_FILE_NAME_WEEKLY={INITIAL_PLAN_DOWNLOAD_FILE_WEEKLY}
      DOWNLOAD_FILE_NAME_MONTHLY={INITIAL_PLAN_DOWNLOAD_FILE_MONTHLY}
      showGraphData={false}
      isInitialPlan={true}
    />
  );
};
